import { apiClientWithRefreshToken } from "@/api/apiClient";

export default async function ExportClients({
    filter,
}: {
    filter?: Record<string, string>;
}) {
    return apiClientWithRefreshToken({
        url: "/clients/export",
        method: "GET",
        responseType: "blob",
        params: {
            ...filter,
        },
    });
}
